<template>
  <div class="checkout-summary">
    <LoadingState v-if="loading" />
    <template v-else>
      <h3 class="text-primary text-uppercase d-flex">
        <span class="m-2">{{ title }}</span>
      </h3>
      <ul class="checkout-summary-list">
        <!-- package -->
        <li class="item" v-for="(item, index) in getLineItems()" :key="`line-item-${index}`">
          <span class="text-secondary">{{ item.title }}:</span>
          <span>{{ item.data }}</span>
        </li>

        <!-- addons -->
        <template v-if="showAddons()">
          <li class="item" v-for="(item, index) in getAddons()" :key="`addon-${index}`">
            <span class="text-secondary">{{ item.title }}</span>
            <span>{{ item.data }}</span>
          </li>
        </template>

        <!-- coupon/discount -->
        <li v-if="coupon" class="item mt-4">
          <span class="text-secondary">{{ $t("global.coupon-code") }}: {{ coupon }}</span>
          <span>{{ `- ${moneyFormat(discount)}` }}</span>
        </li>

        <!-- sales tax -->
        <li class="item">
          <span class="text-secondary">{{ $t("global.sales-tax") }}</span>
          <span>{{ `+ ${moneyFormat(tax)}` }}</span>
        </li>
      </ul>

      <!-- term total -->
      <div class="d-flex justify-content-between mt-5">
        <h3 class="text-secondary">{{ $t("global.total") }}</h3>
        <span class="text-primary h3">
          {{ moneyFormat(total) }} <span class="text-capitalize">{{ term }}</span>
        </span>
      </div>

      <!-- hourly total -->
      <div class="d-flex justify-content-between mt-2">
        <h3></h3>
        <span class="text-secondary h4">
          {{ moneyFormat(hourlyTotal) }}
          <span class="text-capitalize">{{ $t("global.hourly") }}</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { capitalize } from "leatherman-js/utils/formatters/text";
import LoadingState from "@/components/display/LoadingState";
import { moneyFormat } from "leatherman-js/utils/formatters/money";

export default {
  name: "CheckoutCloudServerSummary",
  components: {
    LoadingState,
  },
  props: {
    package: { type: Object },
    addons: { type: Array, default: () => [] },
    title: { type: String },
    term: { type: String, default: "monthly", required: true },
    location: Object,
    distribution: String,
    accessType: String,
    hostname: String,
    coupon: String,
    discount: Number,
    tax: Number,
    total: Number,
    hourlyTotal: Number,
    loading: Boolean,
  },
  setup(props, { root }) {
    const getLineItems = () => {
      let list = [
        {
          title: root.$t("global.data-center"),
          data: props.location?.name || root.$t("global.none-selected"),
        },
        {
          title: root.$t("global.distribution"),
          data: capitalize(props.distribution) || root.$t("global.none-selected"),
        },
        {
          title: root.$t("global.access"),
          data: props.accessType
            ? root.$t(`global.${props.accessType}`)
            : root.$t("global.none-selected"),
        },
        {
          title: root.$t("global.hostname"),
          data: props.hostname || root.$t("global.none-selected"),
        },
      ];

      return list;
    };

    const showAddons = () => props.addons.length;
    const getAddons = () =>
      props.addons.map((addon) => {
        const price = props.term === "monthly" ? addon.monthlyFee : addon.annualFee;
        return {
          title: addon.name,
          data: `+ ${moneyFormat(price)}`,
        };
      });

    return {
      getLineItems,
      getAddons,
      moneyFormat,
      showAddons,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
